import abTestSaga from '~/sagas/ab-test/ab-test.saga';

export default abTestSaga;
